import React, { useState, useEffect, Fragment } from "react";
import styles from "../devicebackup.module.scss";
import { ColumnsType } from "antd/es/table";
import { Button, Card, Table, Input, Form, message, Popconfirm, Row, Col, Tooltip, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import UploadFileModal from "./RepositoryF_UploadModal";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { CharacterVerify } from "../../../Utility/RegExp";
import { useSearchColumn } from "./utils";
import { useDeviceNode } from "Components/Topology/queries";
import { useRepositoryRenameFile, useRepositoryDownload, useRepositoryDeleteFile, useRepositoryList } from "../queries";
// import { useQueryClient } from "react-query";
import FileSaver from "file-saver";
import ReFresh from "Components/Shared/AutoRefresh";

// 用於處理存儲庫文件的操作，包括文件上傳、重命名、下載和刪除等。
const RepositoryC: React.FC = () => {
  const [Renameform] = Form.useForm();
  const [repositoryTableData, setRepositoryTableData] = useState([
    { key: "", name: "", type: "", date: "", model: "", size: "" },
  ]);

  const [visible, setVisible] = useState(false);
  const [modelList, setModelList] = useState<string[]>([]);
  const { t } = useTranslation();
  const [editingKey, setEditingKey] = useState<number | string>("");
  const { level, stateCid, loginCid } = useAppSelector((state) => state.global);
  // const queryClient = useQueryClient();
  const getColumnSearchProps = useSearchColumn();
  const { data: deviceNode } = useDeviceNode(level, stateCid, loginCid);
  const { mutateAsync: renameFileMutation } = useRepositoryRenameFile(stateCid);
  const { mutateAsync: downloadFileMutation } = useRepositoryDownload();
  const { mutateAsync: deleteFileMutation } = useRepositoryDeleteFile(stateCid);
  const { isFetching: repositoryListFetching, data: repositoryList } = useRepositoryList(level, stateCid, loginCid);
  const props = { stateCid, level, loginCid, visible, modelList, setVisible };

  useEffect(() => {
    if (!deviceNode) {
      return;
    }
    if (deviceNode?.response?.nodeInf) {
      let modelList: any = new Set();
      deviceNode.response.nodeInf.forEach((item: any) => {
        modelList.add(item.nodeInf.model);
      });

      modelList = Array.from(modelList);
      modelList.push("Others");
      setModelList(modelList);
    }
  }, [deviceNode]);

  const edit = (index: number) => {
    setEditingKey(index);
  };

  const cancel = () => {
    setEditingKey("");
  };

  useEffect(() => {
    if (repositoryList?.length) {
      let TableData: any[] = [];
      repositoryList.forEach((item: any) => {
        item.list.forEach((list: any) => {
          //set不可以看到yml/Others以外的檔案
          if (level === "set" && list.type !== "yml" && list.type !== "Others") {
            return;
          }
          TableData.push({
            cid: item.cid,
            name: list.name,
            type: list.type,
            date: list.date,
            size: list.size,
            model: list.inf?.model,
            md5: list.inf?.md5,
          });
        });
      });
      // ✅ 複製再反轉，避免影響原始資料
      const reversedData = [...TableData].reverse();
      setRepositoryTableData(reversedData);
    } else {
      setRepositoryTableData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repositoryList]);

  const deleteFile = (record: any) => {
    deleteFileMutation({ level, stateCid, loginCid, record })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const downloadFile = (values: any) => {
    downloadFileMutation({ ...values })
      .then((response) => {
        FileSaver.saveAs(response.data, values.name);
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  let columns: ColumnsType<any> = [
    {
      title: t("ISMS.FileName"),
      dataIndex: "name",
      ...getColumnSearchProps("name"),

      render: (text: string, record: any, index: number) => (
        <Fragment>
          {editingKey !== index ? (
            <div className={styles.rename}>
              <Tooltip title={record.md5 ? `MD5: ${record.md5}` : null}>{text}</Tooltip>
              <Tooltip title={t("ISMS.rename")}>
                <EditOutlined
                  style={level === "get" ? { cursor: "not-allowed" } : {}}
                  className={styles.renameIcon}
                  onClick={() => {
                    Renameform.setFieldsValue({
                      name: record.name,
                    });
                    edit(index);
                  }}
                />
              </Tooltip>
            </div>
          ) : (
            <Form
              layout="vertical"
              form={Renameform}
              onFinish={(values) =>
                renameFileMutation({ record, values })
                  .then(() => {
                    message.success(t("ISMS.Success"));
                  })
                  .catch(() => {
                    message.error(t("ISMS.Fail"));
                  })
                  .finally(() => {
                    cancel();
                  })
              }
            >
              <Row align="middle">
                <Col xs={24} sm={24} md={24} lg={14} xl={14} xxl={18}>
                  <Form.Item
                    style={{ margin: 0 }}
                    name={"name"}
                    rules={[{ required: true, message: "required!" }, CharacterVerify]}
                  >
                    <Input placeholder="New Device Name" maxLength={30} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={5} xl={3} xxl={3}>
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      Renameform.submit();
                    }}
                  >
                    {t("ISMS.Save")}
                  </a>
                </Col>
                <Col xs={24} sm={24} md={24} lg={5} xl={3} xxl={3}>
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      cancel();
                    }}
                  >
                    {t("ISMS.Cancel")}
                  </a>
                </Col>
              </Row>
            </Form>
          )}
        </Fragment>
      ),
    },
    {
      title: t("ISMS.Model"),
      dataIndex: "model",
      filters: modelList.map((item) => {
        return { text: item, value: item };
      }),
      onFilter: (value: any, record: any) => record.model === value,
    },
    {
      title: t("ISMS.FileType"),
      dataIndex: "type",
      filters: [
        {
          text: "fw",
          value: "fw",
        },
        {
          text: "yml",
          value: "yml",
        },
        {
          text: "cfg",
          value: "cfg",
        },
        {
          text: "Others",
          value: "Others",
        },
      ],
      onFilter: (value: any, record: any) => record.type.indexOf(value) === 0,
    },
    {
      title: t("ISMS.CreatedDate"),
      dataIndex: "date",
      responsive: ["md"],
    },
    {
      title: t("ISMS.Size"),
      dataIndex: "size",
      responsive: ["md"],
    },
    {
      title: t("ISMS.Action"),
      dataIndex: "action",
      className: `${styles.actionCol}`,
      render: (_, record: any, index: number) => (
        <Fragment key={index}>
          <Button type="text" onClick={() => downloadFile(record)} icon={<DownloadOutlined />}></Button>
          <Popconfirm title="Sure to delete?" onConfirm={() => deleteFile(record)}>
            <Button type="text" icon={<DeleteOutlined />}></Button>
          </Popconfirm>
        </Fragment>
      ),
    },
  ];

  return (
    <Fragment>
      <UploadFileModal {...props} />
      <Card>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Button
            type="primary"
            disabled={level === "get"}
            loading={repositoryListFetching}
            onClick={() => setVisible(true)}
            className={styles.clickBtn}
            icon={<UploadOutlined style={{ marginBottom: "5px" }} />}
          >
            {t("ISMS.Upload")}
          </Button>

          <Space size={1}>
            <Tooltip title={t("ISMS.Refresh")} style={{ marginLeft: "auto" }}>
              <ReFresh queriesArray={["repositoryList"]} />
            </Tooltip>

            <Tooltip title={t("ISMS.ClearAll")}>
              <Popconfirm
                placement="bottomRight"
                title={t("ISMS.Sure to delete?")}
                okText={t("ISMS.OK")}
                cancelText={t("ISMS.Cancel")}
                onConfirm={() => {
                  deleteFile(undefined);
                }}
              >
                <Button icon={<DeleteOutlined height={"22px"} />}></Button>
              </Popconfirm>
            </Tooltip>
          </Space>
        </div>

        <div>
          <Table
            rowClassName={() => "editable-row"}
            columns={columns}
            dataSource={repositoryTableData}
            pagination={{ showSizeChanger: true }}
            className={styles.table}
            loading={repositoryListFetching}
            rowKey={(record) => record.name}
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default RepositoryC;
